module.exports = __webpack_public_path__ + "static/media/mater.3fe3232f.png";